import { Component, OnInit } from "@angular/core";
import { ClientModel } from "../model/clientModel";
import { ClientService } from "../service/client.service";
import { NgForm } from "@angular/forms";
import { Router } from "@angular/router";

@Component({
  selector: "app-edit-client",
  templateUrl: "./edit-client.component.html",
  styleUrls: ["./edit-client.component.css"],
})
export class EditClientComponent implements OnInit {
  clients: ClientModel[] = [];
  selectedClient: ClientModel | null = null;

  searchTerm: string = "";

  constructor(private clientService: ClientService, private router: Router) {}

  ngOnInit() {
    this.loadClients();
  }

  loadClients() {
    this.clientService.getAllClients().subscribe(
      (response) => {
        console.log(response);
        this.clients = response;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  selectClient(client: ClientModel) {
    this.selectedClient = { ...client };
  }

  backToList() {
    this.selectedClient = null;
  }

  onEditSubmit(editForm: NgForm) {
    if (editForm.valid && this.selectedClient) {
      this.clientService.updateClient(this.selectedClient).subscribe(
        (response) => {
          console.log("Client updated:", response);
          alert("הלקוח עודכן בהצלחה!");
          this.backToList();

          this.loadClients(); // Refresh list
        },
        (error) => {
          console.error("Error updating client:", error);
          alert("Failed to update client");
        }
      );
    }
  }

  deleteClient(client: ClientModel) {
    if (confirm(`בטוח שברצונך למחוק את -  ${client.DestinationName}?`)) {
      this.clientService.deleteClient(client.ClientId!).subscribe(
        (response) => {
          console.log("Client deleted:", response);
          alert("הלקוח נימחק בהצלחה!");
          this.loadClients(); // Refresh list
        },
        (error) => {
          console.error("Error deleting client:", error);
          alert("Failed to delete client");
        }
      );
    }
  }

  deleteSelectedClient() {
    if (
      this.selectedClient &&
      confirm(
        `בטוח שברצונך למחוק את -  ${this.selectedClient.DestinationName}?`
      )
    ) {
      this.clientService.deleteClient(this.selectedClient.ClientId!).subscribe(
        (response) => {
          console.log("Client deleted:", response);
          alert("הלקוח נימחק בהצלחה!");

          this.loadClients(); // Refresh list
        },
        (error) => {
          console.error("Error deleting client:", error);
          alert("Failed to delete client");
        }
      );
    }
  }

  onOpenDetails(client: ClientModel) {
    this.router.navigate(["/clientDetails", client.ClientId]); // or DestinationNumber
  }

  // returns filtered clients according to searchTerm
  get filteredClients(): any[] {
    if (!this.clients || !this.clients.length) return [];
    const term = (this.searchTerm || "").toString().trim().toLowerCase();
    if (!term) return this.clients;
    return this.clients.filter((c: any) => {
      const num = (c.DestinationNumber || "").toString().toLowerCase();
      const name = (c.DestinationName || "").toString().toLowerCase();
      return num.includes(term) || name.includes(term);
    });
  }
}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/edit-client/edit-client.component.ts